import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { CiSearch } from 'react-icons/ci';
import { MdShoppingCart, MdOutlinePayment } from 'react-icons/md';
import { RxHamburgerMenu } from 'react-icons/rx';
import { BsPerson } from 'react-icons/bs';
import { useCart } from '../../contexts/CartProvider';
import styles from './style.module.scss';
import { toast } from 'react-toastify';
import { api } from '../../services/apiClient';
import { useSaldo } from '../../contexts/SaldoContext';
import { useMediaQuery } from 'react-responsive';
import logo from '../../assets/logo.png';
import DropDownCarrinho from '../DropDownCarrinho';


const HeaderComponent = ({ 
  collapsed, 
  toggleCollapsed, 
  onResetStep 
}) => {
  const { user, logout, isAuthenticated } = useAuth();
  const { items } = useCart();
  const [visible, setVisible] = useState(false);
  const [loadingName, setLoadingName] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const { saldo, loading, fetchSaldo } = useSaldo();
  const isMobile = useMediaQuery({ query: '(max-width: 1024px)' });
  const isDesktop = useMediaQuery({ query: '(min-width: 1025px)' });
  const dropdownRef = useRef(null);

  const handleVisibleChange = (newVisible) => {
    setVisible(newVisible);
  };

  const formatarComoMoeda = (valor) => {
    if (valor == null) return '';
    return valor.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchValue.trim()) {
      console.log('Searching for:', searchValue);
      toast.info(`Buscando por: ${searchValue}`);
    }
  };

  const handleCartClick = () => {
    setVisible(!visible);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target )) {
      setVisible(false);
    }
  };

  useEffect(() => {
    fetchSaldo();
  }, []);

  useEffect(() => {
    if (visible) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [visible]);

  const LoadingSpinner = () => (
    <div className={styles.spinner}></div>
  );

  return (
    <header className={styles.container}>
      <div className={styles.containerHeader}>
        {/* Mobile Logo - Always visible on mobile */}
        {isMobile && (
          <div className={styles.logoContainer}>
            <Link to='/'>
              <img src={logo || "/placeholder.svg"} alt='Logo da empresa' className={styles.logo} />
            </Link>
          </div>
        )}

        {/* Left Section - Actions */}
        <div className={styles.leftSection}>
          {/* Insert Credits Button - Always visible */}
          <Link to='/saldo' className={styles.buttonInserirCreditos}>
            <MdOutlinePayment />
            <span>Inserir créditos</span>
          </Link>

          {/* Search Bar - Desktop Only */}
          {/* {isDesktop && (
            <form onSubmit={handleSearchSubmit} className={styles.searchForm}>
              <div className={`${styles.searchContainer} ${isSearchFocused ? styles.focused : ''}`}>
                <CiSearch className={styles.searchIcon} />
                <input
                  type="text"
                  placeholder="Pesquisar por bolões"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  onFocus={() => setIsSearchFocused(true)}
                  onBlur={() => setIsSearchFocused(false)}
                  className={styles.searchInput}
                />
                {searchValue && (
                  <button
                    type="button"
                    onClick={() => setSearchValue('')}
                    className={styles.clearButton}
                  >
                    ×
                  </button>
                )}
              </div>
            </form>
          )} */}
        </div>

        {/* Right Section - Cart and User */}
        <div className={styles.rightSection}>
          {/* Shopping Cart */}
          <div className={styles.cartContainer} ref={dropdownRef}>
            <button 
              className={styles.cartButton}
              onClick={handleCartClick}
            >
              <MdShoppingCart />
              {items && items.length > 0 && (
                <div className={styles.cartBadge}>
                  <span>{items.length}</span>
                </div>
              )}
            </button>

            {/* Cart Dropdown */}
            {visible && (
              <div className={styles.cartDropdown}>
                <DropDownCarrinho 
                  onResetStep={onResetStep} 
                  setVisible={setVisible} 
                />
              </div>
            )}
          </div>

          {/* User Section */}
          <div className={styles.userSection}>
            {isMobile ? (
              /* Mobile Menu Button */
              <button 
                className={styles.menuButton}
                onClick={toggleCollapsed}
                aria-label="Toggle menu"
              >
                <RxHamburgerMenu />
              </button>
            ) : (
              /* Desktop User Info */
              <>
                <Link to='/minha-conta?destino=perfil' className={styles.userIcon}>
                  <BsPerson />
                </Link>

                <div className={styles.userInfo}>
                  {isAuthenticated ? (
                    <Link to='/minha-conta?destino=perfil' className={styles.userLink}>
                      <div className={styles.userDetails}>
                        <h4 className={styles.userName}>
                          Olá, {loadingName ? (
                            <LoadingSpinner />
                          ) : (
                            user?.nome?.length > 10 
                              ? `${user.nome.substring(0, 10)}...` 
                              : user?.nome
                          )}
                        </h4>
                        <p className={styles.userBalance}>
                          Saldo
                          <span className={styles.balanceValue}>
                            {loading ? <LoadingSpinner /> : formatarComoMoeda(saldo)}
                          </span>
                        </p>
                      </div>
                    </Link>
                  ) : (
                    <div className={styles.authButtons}>
                      <Link to='/login' className={styles.loginButton}>
                        Entre <span className={styles.separator}>ou</span>
                      </Link>
                      <Link to='/cadastrar' className={styles.registerButton}>
                        cadastre-se
                      </Link>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeaderComponent;
